import React, {useCallback, useEffect, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import AngleLeft from '../../../assets/icons/AngleLeft.svg'
import AngleRight from '../../../assets/icons/AngleRight.svg'
import ResponsiveImg from '../../common/ResponsiveImg'
import {Locale, ScreenType, SM_WIDTH} from '../../../config/constants'
import {useLocale, useWindowDimensions} from '../../hocs/hooks'
import styles from './Pickup.scss'
import bannerGuide from '../../../assets/imgs/new-vanshare/lp_banner_guide.jpg'
import bannerGuideDimension from '../../../assets/imgs/new-vanshare/lp_banner_guide.jpg?size'
import bannerTour from '../../../assets/imgs/new-vanshare/lp_banner_tour.jpg'
import bannerTourDimension from '../../../assets/imgs/new-vanshare/lp_banner_tour.jpg?size'
import bannerUsage from '../../../assets/imgs/new-vanshare/lp_banner_usage_2.jpg'
import bannerUsageDimension from '../../../assets/imgs/new-vanshare/lp_banner_usage_2.jpg?size'
import bannerManner from '../../../assets/imgs/new-vanshare/lp_banner_manner_2.jpg'
import bannerMannerDimension from '../../../assets/imgs/new-vanshare/lp_banner_manner_2.jpg?size'
import bannerInsurance from '../../../assets/imgs/new-vanshare/lp_banner_insurance_2.jpg'
import bannerInsuranceDimension from '../../../assets/imgs/new-vanshare/lp_banner_insurance_2.jpg?size'
import bannerHolder from '../../../assets/imgs/new-vanshare/lp_banner_holder.jpg'
import bannerHolderDimension from '../../../assets/imgs/new-vanshare/lp_banner_holder.jpg?size'

const Pickup = ({ showUsage = true, headMargin = true }: { showUsage?: boolean, headMargin?: boolean }) => {
  const locale = useLocale()
  const bannerListRef = useRef<HTMLUListElement>(null)
  const { width } = useWindowDimensions()
  const isMd = width < SM_WIDTH
  const [isOverflow, setIsOverflow] = useState(false)
  const [isLeftTouch, setIsLeftTouch] = useState(true)
  const [isRightTouch, setIsRightTouch] = useState(false)
  useEffect(() => {
    const list = bannerListRef.current
    setIsOverflow(!!list && (list.scrollWidth >= list.offsetWidth))
    setIsRightTouch(!!list && (list.scrollWidth <= list.offsetWidth))
  }, [width])
  const onScroll = useCallback(() => {
    const list = bannerListRef.current
    if (!list) return
    setIsLeftTouch(list.scrollLeft === 0)
    setIsRightTouch(list.scrollLeft + list.offsetWidth >= list.scrollWidth)
  }, [])
  useEffect(() => {
    bannerListRef.current?.addEventListener('scroll', onScroll)
    return () => bannerListRef.current?.removeEventListener('scroll', onScroll)
  }, [onScroll])
  const scrollBanner = (e: any, isRight: boolean = true) => {
    const list = bannerListRef.current
    list?.scrollBy({
      left: isRight ? -409 : 409,
      behavior: 'smooth'
    })
  }
  return <>
    {locale === Locale.ja && typeof window === 'object' && <div className="py-11px py-md-3 position-relative">
      <button
        onClick={scrollBanner}
        className={[
          'rounded-circle position-absolute border-0 bg-white shadow',
          !isOverflow || isLeftTouch && 'd-none', styles.angleLeft
        ].filter(Boolean).join(' ')}
      >
        <AngleLeft className={[styles.angle].join(' ')}/>
      </button>
      <ul
        ref={bannerListRef}
        className={['mt-0 mb-0 list-unstyled d-flex overflow-auto', !headMargin && 'pl-0', styles.scroll].filter(Boolean).join(' ')}
      >
        {showUsage && <li
          className={'pr-md-4 pb-md-0 ml-auto'}
          title="ご利用ガイド"
        >
          <Link to={`/${locale}/usage/`}>
            <ResponsiveImg
              width={isMd ? 220 : 320}
              caption="ご利用ガイド"
              url={bannerGuide}
              dimension={bannerGuideDimension}
            />
          </Link>
        </li>}
        <li className={['pr-md-4 pb-3 pb-md-0', !showUsage && 'ml-auto'].filter(Boolean).join(' ')}
            title="キャンピングカーをお持ちの方へ">
          <Link to={`/${locale}/holder/`}>
            <ResponsiveImg
              width={isMd ? 220 : 320}
              caption="キャンピングカーをお持ちの方へ"
              scales={{ [ScreenType.md]: 3 }}
              url={bannerHolder}
              dimension={bannerHolderDimension}
            />
          </Link>
        </li>
        <li className={'pr-md-4 pb-3 pb-md-0'}
            title="はじめてのVANLIFE4選">
          <Link to={`/${locale}/vanlife/`}>
            <ResponsiveImg
              width={isMd ? 220 : 320}
              caption="はじめてのVANLIFE4選"
              scales={{ [ScreenType.md]: 3 }}
              url={bannerTour}
              dimension={bannerTourDimension}
            />
          </Link>
        </li>
        <li className={'pr-md-4 pb-3 pb-md-0'}
            title="運転の仕方">
          <Link to={`/${locale}/safety/`}>
            <ResponsiveImg
              width={isMd ? 220 : 320}
              caption="運転の仕方"
              scales={{ [ScreenType.md]: 3 }}
              url={bannerUsage}
              dimension={bannerUsageDimension}
            />
          </Link>
        </li>
        <li className={'pr-md-4 pb-3 pb-md-0'}
            title="車中泊・キャンプのマナーについて">
          <Link to={`/${locale}/vanlife-manner/`}>
            <ResponsiveImg
              width={isMd ? 220 : 320}
              caption="車中泊・キャンプのマナーについて"
              url={bannerManner}
              dimension={bannerMannerDimension}
            />
          </Link>
        </li>
        <li className={'pb-3 pb-md-0 mr-auto'}
            title="Carstayの自動車保険について">
          <a href="https://persistent-direction-0f1.notion.site/c654c36070a74fbcba29eda5160b4c3c"
             target="_blank"
             rel="noopener noreferrer">
            <ResponsiveImg
              width={isMd ? 220 : 320}
              caption="Carstayの自動車保険について"
              url={bannerInsurance}
              dimension={bannerInsuranceDimension}
            />
          </a>
        </li>
        <li className={styles.dummy}></li>
      </ul>
      <button
        onClick={e => scrollBanner(e, false)}
        className={[
          'rounded-circle position-absolute border-0 bg-white shadow',
          !isOverflow || isRightTouch && 'd-none', styles.angleRight
        ].join(' ')}
      >
        <AngleRight className={[styles.angle].join(' ')}/>
      </button>
    </div>}
  </>
}
Pickup.displayName = 'Pickup'
export default Pickup
